import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

const ControlledTab = ({ isPMMode, onTabChange }) => {
  const [key, setKey] = useState(null);

  useEffect(() => {
    if (isPMMode) {
      setKey("profile");
    } else {
      setKey("home");
    }
  }, [isPMMode]);
  const handleTabChange = (k) => {
    setKey(k);
    onTabChange(k);
  };

  return (
    <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={handleTabChange}
      className="mb-3 custom-tabs"
    >
      <Tab eventKey="home" title="Student Results"></Tab>

      <Tab eventKey="profile" title="Progress Monitoring"></Tab>
    </Tabs>
  );
};

export default ControlledTab;
